module.exports = __webpack_public_path__ + "img/2026big9.9e5faf7d.png";